import { MouseEvent, ReactElement } from 'react';
import { getClasses, parsePhoneNumber } from '@/utils';

import Input from '@/common/Input';
import Table from '@/common/Table';
import { Vehicle } from '@/models/gen/graphql';
import { getVehicleTableGridTemplateColumns } from './utils';
import { useVehiclesState } from '@/features/Vehicles';

const VehicleTableRow = ({ id, licensePlate, vin, trackingId, airportCodes, location, phoneNumber, active }: Vehicle): ReactElement => {
  const [{ isSelected, onSelect, onDoubleClick, settings }] = useVehiclesState(({ state, setState }) => [
    {
      isSelected: state.selected.includes(id),
      onSelect: (): void => state.onSelect(id),
      onDoubleClick: (event: MouseEvent<HTMLTableRowElement>): void => {
        event.preventDefault();
        event.stopPropagation();
        setState((current) => ({
          ...current,
          selected: [id],
          modals: { ...current.modals, editVehicle: { show: true } },
        }));
      },
      settings: state.settings,
    },
  ]);

  const airportDisplay =
    typeof airportCodes === 'string'
      ? airportCodes
      : (airportCodes || []).map(({ airportCode }: { airportCode: string }): string => airportCode).join(', ');

  const statusLabel = Number(active) ? 'Active' : 'Inactive';
  const statusClass = Number(active) ? 'active' : 'inactive';

  const gridTemplateColumns = getVehicleTableGridTemplateColumns(settings);

  return (
    <Table.Row id={id} className={getClasses(isSelected && 'selected')} onDoubleClick={onDoubleClick} style={{ gridTemplateColumns }}>
      {settings.columns.SELECT && (
        <Table.Cell className="SELECT">
          <Input type="checkbox" onClick={onSelect} checked={isSelected} />
        </Table.Cell>
      )}
      {settings.columns.TAG && (
        <Table.Cell className="TAG" data-placeholder="--">
          {licensePlate || ''}
        </Table.Cell>
      )}
      {settings.columns.VIN && (
        <Table.Cell className="VIN" data-placeholder="--">
          {vin || ''}
        </Table.Cell>
      )}
      {settings.columns.VEHICLE_NO && (
        <Table.Cell className="VEHICLE-NO" data-placeholder="--">
          {trackingId || ''}
        </Table.Cell>
      )}
      {settings.columns.AIRPORT && (
        <Table.Cell className="AIRPORT" data-placeholder="--">
          {airportDisplay || ''}
        </Table.Cell>
      )}
      {settings.columns.EXCHANGE_PLACE && (
        <Table.Cell className="EXCHANGE-PLACE" data-placeholder="--">
          {location?.name || ''}
        </Table.Cell>
      )}
      {settings.columns.PHONE && (
        <Table.Cell className="PHONE" data-placeholder="--">
          {phoneNumber ? parsePhoneNumber(phoneNumber, ' ') : ''}
        </Table.Cell>
      )}
      {settings.columns.STATUS && (
        <Table.Cell className={getClasses('STATUS', statusClass)} data-placeholder="--">
          {statusLabel}
        </Table.Cell>
      )}
    </Table.Row>
  );
};

export default VehicleTableRow;
